/**
 * 环境检测工具
 */

/**
 * 获取当前运行环境
 * @returns {Object} 环境信息对象
 * @property {boolean} isWeb - 是否为普通浏览器环境
 * @property {boolean} isMobile - 是否为移动端环境
 * @property {boolean} isWechat - 是否为微信环境
 * @property {boolean} isAndroid - 是否为安卓环境
 * @property {boolean} isIOS - 是否为iOS环境
 */
export function getEnv() {
  const ua = navigator.userAgent.toLowerCase()

  // 判断是否为移动端
  const isMobile = /mobile|android|iphone|ipad|phone/i.test(ua)

  // 判断是否为微信环境
  const isWechat = /micromessenger/i.test(ua)

  // 判断是否为安卓环境
  const isAndroid = /android/i.test(ua)

  // 判断是否为iOS环境
  const isIOS = /iphone|ipad|ipod/i.test(ua)

  // 判断是否为普通浏览器环境
  const isWeb = !isWechat && !isMobile

  return {
    isWeb,
    isMobile,
    isWechat,
    isAndroid,
    isIOS
  }
}

/**
 * 获取当前环境类型
 * @returns {string} 环境类型：'web' | 'mobile' | 'wechat'
 */
export function getUaType() {
  const { isMobile, isWechat } = getEnv()

  if (isWechat) {
    return 'wap_wx'
  }

  if (isMobile) {
    return 'wap_h5'
  }

  return 'web'
}